import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { LayoutDashboardIcon, PlaneIcon, CompassIcon, RadioIcon, BookOpenIcon, TargetIcon, MenuIcon, BellIcon, ArrowLeftIcon, SparklesIcon } from 'lucide-react';
interface ParticipantHubLayoutProps {
  children: React.ReactNode;
}
export function ParticipantHubLayout({
  children
}: ParticipantHubLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navItems = [{
    label: 'Hub Overview',
    path: '/experience-hub',
    icon: LayoutDashboardIcon,
    exact: true
  }, {
    label: 'Flight Pack',
    path: '/experience-hub/flight-pack',
    icon: PlaneIcon
  }, {
    label: 'Arrival Briefing',
    path: '/experience-hub/arrival',
    icon: CompassIcon
  }, {
    label: 'Live Companion',
    path: '/experience-hub/live',
    icon: RadioIcon
  }, {
    label: 'Knowledge Studio',
    path: '/experience-hub/knowledge',
    icon: BookOpenIcon
  }, {
    label: 'Action Plan',
    path: '/experience-hub/action-plan',
    icon: TargetIcon
  }];
  return <div className="min-h-screen bg-stone-50 flex font-sans text-slate-800" data-id="element-4828">
      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && <div className="fixed inset-0 bg-slate-900/50 z-40 lg:hidden" onClick={() => setSidebarOpen(false)} data-id="element-4829" />}

      {/* Sidebar */}
      <aside className={`fixed inset-y-0 left-0 z-50 w-64 bg-[#0B1B3B] text-white flex flex-col transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:shrink-0 border-r border-slate-800 ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`} data-id="element-4830">
        {/* Brand Header */}
        <div className="p-6 border-b border-white/10" data-id="element-4831">
          <div className="font-serif-display text-2xl font-bold tracking-tight mb-1" data-id="element-4832">
            Offsite+
          </div>
          <div className="text-[10px] font-bold text-amber-500 uppercase tracking-[0.2em]" data-id="element-4833">
            Retreat Intelligence Hub
          </div>
        </div>

        {/* Participant Context */}
        <div className="p-4 border-b border-white/10" data-id="element-4834">
          <div className="flex items-center gap-3 p-2 rounded-lg hover:bg-white/5 transition-colors cursor-pointer" data-id="element-4835">
            <div className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center shrink-0 border border-white/20" data-id="element-4836">
              <span className="text-sm font-bold text-amber-500" data-id="element-4837">FC</span>
            </div>
            <div className="overflow-hidden" data-id="element-4838">
              <div className="font-bold text-sm truncate" data-id="element-4839">Finova Capital</div>
              <div className="text-xs text-slate-400 truncate" data-id="element-4840">
                Executive Summit
              </div>
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1" data-id="element-4841">
          {navItems.map(item => <NavLink key={item.label} to={item.path} end={item.exact} className={({
          isActive
        }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? 'bg-amber-500/10 text-amber-500 border-l-2 border-amber-500' : 'text-slate-300 hover:bg-white/5 hover:text-white border-l-2 border-transparent'}`} data-id="element-4842">
              <item.icon className="w-4 h-4 shrink-0" data-id="element-4843" />
              {item.label}
            </NavLink>)}
        </nav>

        {/* Footer Link */}
        <div className="p-4 border-t border-white/10" data-id="element-4844">
          <Link to="/" className="flex items-center gap-2 text-xs font-medium text-slate-400 hover:text-white transition-colors" data-id="element-4845">
            <div className="w-6 h-6 rounded-full bg-white/10 flex items-center justify-center" data-id="element-4846">
              <ArrowLeftIcon className="w-3 h-3" data-id="element-4847" />
            </div>
            Back to Portal
          </Link>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0" data-id="element-4848">
        {/* Top Bar */}
        <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 lg:px-8 sticky top-0 z-30" data-id="element-4849">
          <div className="flex items-center gap-4 flex-1" data-id="element-4850">
            <button className="lg:hidden p-2 -ml-2 text-slate-500 hover:text-slate-800" onClick={() => setSidebarOpen(true)} data-id="element-4851">
              <MenuIcon className="w-5 h-5" data-id="element-4852" />
            </button>
            <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 bg-amber-50 text-amber-700 rounded-full text-xs font-semibold border border-amber-100" data-id="element-4853">
              <SparklesIcon className="w-3.5 h-3.5" data-id="element-4854" />
              AI-ENHANCED DELIVERY
            </div>
          </div>
          <div className="flex items-center gap-6 shrink-0" data-id="element-4855">
            <button className="text-slate-400 hover:text-slate-600 relative" data-id="element-4856">
              <BellIcon className="w-5 h-5" data-id="element-4857" />
              <span className="absolute top-0 right-0 w-2 h-2 bg-rose-500 rounded-full border-2 border-white" data-id="element-4858" />
            </button>
            <div className="flex items-center gap-3" data-id="element-4859">
              <div className="text-right hidden sm:block" data-id="element-4860">
                <div className="text-sm font-bold text-slate-900" data-id="element-4861">
                  Sarah Jenkins
                </div>
                <div className="text-xs text-slate-500" data-id="element-4862">Participant</div>
              </div>
              <div className="w-9 h-9 rounded-full bg-[#0B1B3B] text-white flex items-center justify-center text-sm font-bold" data-id="element-4863">
                SJ
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-x-hidden" data-id="element-4864">{children}</main>
      </div>
    </div>;
}